(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["react-use-state-with-callback"] = factory(require("react"));
	else
		root["react-use-state-with-callback"] = factory(root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__9__) {
return 